import { get, compact, range, chain } from 'lodash'
import moment from 'moment'
import { createSelector } from 'reselect'

import { getHoursData } from '../../../lib/timetable'

export const emptyDay = {
  isOpen: true,
  times: ["13:00", "13:30", "14:00", "14:30", "15:00"],
  allDayTimes: ""
}

const defaultSchedule = {
  key: 'default',
  startDate: '2019/01/01',
  endDate: '2030/12/31',
  note: '',
  weekDays: [
    /* Domingo */ emptyDay,
    /* Lunes */ emptyDay,
    /* Martes */ emptyDay,
    /* Miercoles */ emptyDay,
    /* Jueves */ emptyDay,
    /* Viernes */ emptyDay,
    /* Sabado */ emptyDay,
  ]
}

const defaultTimeTable = {
  allDay: false,
  schedules: {defaultSchedule},
  exceptions: {}
}

export const getCity = (_state, _ownProps) => (
  compact(get(this.props, ["wholeState", "router", "location", "pathname"], "/kek/madrid/lol").split("/"))[1]
)


export const getTimeData = createSelector(
  [
    (_, ownProps) => ownProps.product,
    (_, ownProps) => ownProps.margin || 0
  ],
  (product, margin) => {
    const {timetable} = product

    console.log(`gonna do getTimeData for timetable ${timetable} with margin ${margin}`)
    const dayCursor = moment()
    const buildTimeTable = timetable
      ? range(0, 60)
        .map((_x, i) => {
          if (i != 0) dayCursor.add(1, "days")
          if (i >= margin) return getHoursData(timetable, dayCursor)
          else return null
        })
        .filter(day => day && ((timetable.allDay == false && day.times.length > 0) || timetable.allDay))

      : []

    if (buildTimeTable.length > 0) return buildTimeTable
    else return range(0, 60)
      .map((_x, i) => {
        if (i != 0) dayCursor.add(1, "days")
        if (i >= margin) return getHoursData(defaultTimeTable, dayCursor)
        else return null
      })
      .filter(day => day && day.times.length > 0)
  }
)



// WEBPACK FOOTER //
// ./src/app/catalogo/selectors/timetables.js